var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnknownDevice = function SvgUnknownDevice(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 23",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 22.5c6.075 0 11-4.925 11-11S17.075.5 11 .5 0 5.425 0 11.5s4.925 11 11 11m0-4.24a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75M9.09 9.429A1.91 1.91 0 0 1 11 7.518c1.048 0 1.91.862 1.91 1.91 0 .485-.208.659-1.026 1.224-.363.25-.86.598-1.246 1.108-.415.546-.67 1.227-.67 2.093h2.063c0-.424.113-.666.25-.846.164-.217.402-.4.775-.659l.124-.084c.676-.46 1.792-1.219 1.792-2.836A3.98 3.98 0 0 0 11 5.456a3.97 3.97 0 0 0-3.973 3.972z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnknownDevice);
export { ForwardRef as Icon };
export default "img/element-icons/settings/unknown-device.a72c1a6.svg";